import { useRef } from 'react'; // Importar useRef
import { generateSessionId } from './utils/session'; // Importar generateSessionId
import styled, { ThemeProvider } from 'styled-components';
import { Toaster } from 'react-hot-toast'; // Importar Toaster
import GlobalStyle from './styles/GlobalStyle';
import theme from './styles/theme';
// Remover imports dos componentes que agora estão em ChatView
// import Header from './components/Header';
// import ChatInput from './components/ChatInput';
// import ChatHistory from './components/ChatHistory';
// import Feedback from './components/Feedback';
import Sidebar from './components/Sidebar';
import ChatView from './components/ChatView'; // Importar ChatView

// Layout principal com duas colunas
const AppLayout = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  background-color: #111b21; /* Fundo geral dark (ajustado) */
  overflow: hidden; /* Evitar scroll da página inteira */

  /* Media Query para telas menores (ex: <= 768px) */
  @media (max-width: 768px) {
    flex-direction: column; /* Empilhar verticalmente */
    overflow-y: auto; /* Permitir scroll vertical se necessário */
    height: auto; /* Altura automática para conteúdo */
    min-height: 100vh; /* Garantir altura mínima */
  }
`;

// Wrapper para a Sidebar (Coluna Esquerda)
const SidebarWrapper = styled.aside`
  width: 30%; /* Largura da coluna esquerda em telas grandes */
  max-width: 400px; /* Largura máxima em telas grandes */
  min-width: 300px; /* Largura mínima em telas grandes */
  display: flex;
  flex-direction: column;
  background-color: #111b21; /* Fundo dark da sidebar (ajustado) */
  border-right: 1px solid #202c33; /* Divisor dark */
  flex-shrink: 0; /* Evitar que encolha demais */

  /* Media Query para telas menores */
  @media (max-width: 768px) {
    width: 100%; /* Ocupar largura total */
    max-width: none; /* Remover largura máxima */
    min-width: 0; /* Remover largura mínima */
    border-right: none; /* Remover borda direita */
    border-bottom: 1px solid #202c33; /* Adicionar borda inferior */
    /* Altura pode precisar de ajuste dependendo do conteúdo, mas flex-direction: column no pai ajuda */
  }
`;

// Wrapper para a Visão do Chat (Coluna Direita)
const ChatViewWrapper = styled.main`
  flex-grow: 1; /* Ocupa o restante do espaço (largura ou altura) */
  display: flex;
  flex-direction: column;
  background-color: #0b141a; /* Fundo da área de chat dark (ajustado) */
  min-width: 0; /* Permitir encolher */

  /* Media Query para telas menores */
   @media (max-width: 768px) {
     /* Já ocupa 100% da largura devido ao flex-direction: column no pai */
     /* Garantir que possa crescer verticalmente */
     flex-grow: 1;
   }
`;


// Remover styled-components movidos para ChatView
/*
const ChatHistoryContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  padding: 1rem;
  width: 100%;
  background: #e5ddd5;
`;

const FooterContainer = styled.div`
  width: 100%;
  background: #f0f2f5;
  padding-bottom: 1rem;
`;

const Intro = styled.section`
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: 1.1rem;
`;
*/

/* Loader agora está definido em ChatView.jsx
const Loader = styled.div`
  margin: 1.5rem auto;
  width: 36px;
  height: 36px;
  border: 4px solid ${({ theme }) => theme.colors.primary};
  border-top: 4px solid transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
*/

// App agora monta o layout e gerencia o sessionId
function App() {
  // Gerar o sessionId aqui para passar para os filhos
  const sessionIdRef = useRef(generateSessionId());

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      {/* Adicionar Toaster aqui, fora do layout principal mas dentro do ThemeProvider */}
      <Toaster
        position="top-center" // Mudar posição para o centro superior
        reverseOrder={false} // Ordem padrão
        toastOptions={{
          // Estilos básicos para combinar com o tema dark e aumentar tamanho
          style: {
            background: '#333', // Fundo escuro
            color: '#fff', // Texto branco
            fontSize: '1.1rem', // Aumentar tamanho da fonte
            padding: '1rem 1.5rem', // Aumentar padding interno
            minWidth: '250px', // Garantir uma largura mínima
            maxWidth: '500px', // Limitar largura máxima
          },
          success: {
            // Estilos específicos para sucesso (opcional)
            duration: 4000, // Aumentar duração para 4 segundos (2s padrão + 2s)
            iconTheme: {
              primary: '#00a884', // Ícone verde
              secondary: '#fff',
            },
          },
          error: {
            // Estilos específicos para erro (opcional)
            duration: 6000, // Aumentar duração para 6 segundos (4s padrão + 2s)
            iconTheme: {
              primary: '#f44336', // Ícone vermelho
              secondary: '#fff',
            },
          },
        }}
      />
      {/* Usar AppLayout como container principal */}
      <AppLayout>
        {/* Coluna Esquerda */}
        <SidebarWrapper>
          {/* Passar sessionId para Sidebar */}
          <Sidebar sessionId={sessionIdRef.current} />
        </SidebarWrapper>

        {/* Coluna Direita */}
        <ChatViewWrapper>
           {/* Passar sessionId para ChatView */}
           <ChatView sessionId={sessionIdRef.current} />
        </ChatViewWrapper>
      </AppLayout>
    </ThemeProvider>
  );
}

export default App;
